export const text = [
  {
    label: "Total asset ($)",
    info: "The total asset is the sum of balance and total investment minus total liabilities. There are a large number of tokens and we consider the top ones only.",
  },
  {
    label: "Liquidation penalty",
    info: "The wallet will get penalty points if some of its borrows were liquidated",
  },
  {
    label: "Ratio of Deposit to Total asset (%)",
    info: "The ratio of the Deposit to the Total asset. By depositing and borrowing multiple times, we can deposit up to 300% the initial capital",
  },
  {
    label: "Ratio of Borrow to Deposit (%)",
    info: "The ratio of the Borrow to the Deposit. The Borrow is limited by the loan-to-value ratio, which is 80% on average. For example, if you deposit 100 USDT, you can borrow 80 DAI in maximum.",
  },
  {
    label: "Average amount of transactions per day ($)",
    info: "The average total amount (in USD) transferred into the wallet every day",
  },
  {
    label: "Average number of transactions per day",
    info: "The average number of transactions triggered by the wallet every day",
  },
  {
    label: "Age of wallet (day)",
    info: "The period of time that the wallet has participated in the crypto market, since its first transaction",
  },
  {
    label: "Trustworthiness of possessing assets",
    info: "Trustworthiness of possessing assets is a complex factor and is not modelled in this simulation tool. Please enter a value between 0 and 1000 to represent the trustworthiness of tokens held by the wallet.",
  },
  {
    label: "Number of monitoring days",
    info: "The number of days that you would like to monitor the credit scores",
  },
];
